import React, { Component } from "react";
import queryString from "query-string";

import { __ROOTPATH__ } from "./../../../services/db";
import ReactGA from "react-ga";
import totalPrice from "./TotalPrice";

export class Header extends Component {
  state = {
    steps: null,
    wizardData: null,
    location: null,
    totalPrice: 0
  };

  static getDerivedStateFromProps(props, state) {
    if (props.location !== state.location) {
      const { location } = props;
      const urlParams = queryString.parse(location.search);
      const wizardData = props.wizardData;

      const totalPriceWizard = totalPrice(
        wizardData,
        urlParams,
        state.totalPrice
      );

      return {
        wizardData,
        urlParams,
        totalPrice: totalPriceWizard
      };
    }
    return null;
  }

  render() {
    const { location } = this.props;
    const { totalPrice } = this.state;
    let sendToCartURL = null;

    if (location) {
      const wizardId = location.pathname.replace("/", "");
      const searchURLValues = location.search.replace("?", "");
      sendToCartURL = `wizard=${wizardId}&${searchURLValues}`;
    }

    return (
      <div className="header-wizard clearfix" data-test="HeaderComponent">
        <div className="container-fluid">
          <a className="navbar-brand">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="71"
              height="25"
              viewBox="0 0 71 25"
              className="d-lg-none"
            >
              <g fill="none">
                <path fill="#000" d="M-145-14h361v52h-361z" />
                <path
                  fill="#FFF"
                  d="M43.24 12.334C43.24 5.318 37.822 0 30.913 0c-6.91 0-12.33 5.318-12.33 12.334s5.42 12.368 12.33 12.368S43.24 19.35 43.24 12.334M58.07 0C64.981 0 70.4 5.318 70.4 12.334s-5.42 12.368-12.329 12.368c-6.91 0-12.329-5.352-12.329-12.368S51.162 0 58.071 0zM2.984.716l6.503 12.062L15.956.716h2.984L10.826 15.69v9.012H8.114V15.69L0 .716h2.984zm28.106 1.79c5.087 0 9.292 4.069 9.292 9.828 0 5.758-4.205 9.862-9.292 9.862-5.086 0-9.291-4.104-9.291-9.862 0-5.759 4.205-9.828 9.291-9.828zm26.802 0c-5.086 0-9.291 4.069-9.291 9.828 0 5.758 4.205 9.862 9.291 9.862 5.087 0 9.292-4.104 9.292-9.862 0-5.759-4.205-9.828-9.292-9.828z"
                />
              </g>
            </svg>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="86"
              height="44"
              viewBox="0 0 86 44"
              className="d-none d-lg-flex"
            >
              <g fill="#FFF">
                <path d="M52.822 14.98c0-8.522-6.62-14.98-15.06-14.98C29.32 0 22.7 6.458 22.7 14.98 22.7 23.5 29.32 30 37.76 30c8.441 0 15.061-6.5 15.061-15.02M70.94 0C79.379 0 86 6.458 86 14.98 86 23.5 79.38 30 70.939 30c-8.44 0-15.06-6.5-15.06-15.02 0-8.522 6.62-14.98 15.06-14.98zM3.645.87l7.944 14.649L19.492.869h3.645l-9.912 18.186V30H9.912V19.055L0 .87h3.645zM37.98 3.043c6.213 0 11.35 4.942 11.35 11.936s-5.137 11.978-11.35 11.978c-6.214 0-11.35-4.984-11.35-11.978S31.765 3.043 37.98 3.043zm32.74 0c-6.213 0-11.35 4.942-11.35 11.936s5.137 11.978 11.35 11.978c6.214 0 11.351-4.984 11.351-11.978S76.934 3.043 70.721 3.043z"></path>
                <path d="M4.972 39.598l-1.647-2.826H2.173l2.259 3.816V43h1.062v-2.412l2.259-3.816H6.61l-1.638 2.826zm9.78.288c0-1.89-1.503-3.231-3.285-3.231-1.791 0-3.294 1.341-3.294 3.231 0 1.899 1.503 3.24 3.294 3.24 1.782 0 3.285-1.35 3.285-3.24zm-1.08 0c0 1.35-.99 2.304-2.205 2.304s-2.205-.954-2.205-2.304c0-1.35 1.017-2.295 2.205-2.295 1.188 0 2.205.945 2.205 2.295zm5.037 2.322c-.963 0-1.467-.594-1.467-1.656v-3.78H16.18v3.861c0 1.557 1.035 2.493 2.529 2.493 1.503 0 2.529-.936 2.529-2.493v-3.861h-1.053v3.78c0 1.062-.504 1.656-1.476 1.656zm5.415-1.863h.783L26.626 43h1.188l-1.8-2.772c.8-.225 1.296-.801 1.296-1.665 0-1.152-.882-1.791-2.17-1.791h-2.078V43h1.062v-2.655zm0-.918v-1.719h1.08c.684 0 1.044.297 1.044.864 0 .558-.36.855-1.044.855h-1.08zm13.512.459c0-1.89-1.503-3.231-3.285-3.231-1.791 0-3.294 1.341-3.294 3.231 0 1.899 1.503 3.24 3.294 3.24 1.782 0 3.285-1.35 3.285-3.24zm-1.08 0c0 1.35-.99 2.304-2.205 2.304s-2.205-.954-2.205-2.304c0-1.35 1.017-2.295 2.205-2.295 1.188 0 2.205.945 2.205 2.295zM40.162 43v-4.545L43.096 43h1.053v-6.228h-1.044v4.617l-2.934-4.617h-1.044V43h1.035zm5.873 0h3.934v-.945h-2.872v-1.764h2.484v-.945h-2.484v-1.629h2.871v-.945h-3.933V43zm12.288.396v-1.359l-2.466-2.7c-.432-.477-.783-.855-.783-1.287 0-.378.297-.603.693-.603.432 0 .747.288.756.828h1c-.046-1.026-.757-1.62-1.71-1.62-1.009 0-1.71.603-1.71 1.386 0 .477.26.927.584 1.341-.72.468-1.233 1.152-1.233 1.935 0 1.008.73 1.809 1.908 1.809.792 0 1.377-.423 1.701-1.107l1.26 1.377zm-3.843-2.16c0-.459.27-.873.756-1.224l1.485 1.629a1.406 1.406 0 0 1-1.179.666c-.63 0-1.062-.468-1.062-1.071zm13.485-1.35c0-1.89-1.503-3.231-3.285-3.231-1.79 0-3.294 1.341-3.294 3.231 0 1.899 1.503 3.24 3.294 3.24 1.782 0 3.285-1.35 3.285-3.24zm-1.08 0c0 1.35-.99 2.304-2.205 2.304s-2.205-.954-2.205-2.304c0-1.35 1.017-2.295 2.205-2.295 1.188 0 2.205.945 2.205 2.295zM70.491 43v-4.545L73.425 43h1.053v-6.228h-1.044v4.617L70.5 36.772h-1.044V43h1.035zm5.874 0h3.771v-.972h-2.709v-5.256h-1.062V43zm6.306-3.402l1.638-2.826h1.143l-2.259 3.816V43h-1.062v-2.412l-2.259-3.816h1.152l1.647 2.826z"></path>
              </g>
            </svg>
          </a>
          <div className="price">
            <ReactGA.OutboundLink
              eventLabel="Comprátelo YA"
              to={`${__ROOTPATH__}/carrito?${sendToCartURL}&from-wizard=true`}
              target="_self"
            >
              <p>Comprátelo YA</p>
              <p className="total-price">{totalPrice && totalPrice} €</p>
            </ReactGA.OutboundLink>
          </div>
        </div>
      </div>
    );
  }
}

export default Header;
